import Vue from "vue";
import LocationCard from "@/components/Util/LocationCard/LocationCard.vue";
import { Component } from "vue-property-decorator";
import { bus } from "@/main";

const SearchBarIframeProps = Vue.extend({
  props: {}
});

@Component({
  name: "SearchBarIframe",
  components: {
    LocationCard
  },
})
export default class SearchBarIframe extends SearchBarIframeProps {
}
